import styled from 'styled-components'

export const LabelStyle = styled.label`
  display: block;
  ${({ font }) => font && `font-family: ${font};`}
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}px;`}
  ${({ color }) => color && `color: ${color};`}
`
